<template>
  <div>
    <div
      v-if="loading"
      class="
        w-full
        bg-white/75
        absolute
        inset-0
        flex
        items-center
        justify-center
      "
    >
      <fa
        :icon="['fal', 'circle-notch']"
        class="text-5xl text-indigo-400 fa-spin"
      />
    </div>
    <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 mt-6">
      <div
        v-for="review in results"
        :key="review.uuid"
        class="flex"
      >
        <vetster-review
          :v-key="`review-${review.uuid}`"
          :review="review"
        />
      </div>
    </div>
    <div
      v-if="hasResults"
      class="pt-6 pb-4"
    >
      <vetster-pagination
        :total="meta.total"
        :from="meta.from"
        :to="meta.to"
        :current-page="meta.current_page"
        :last-page="meta.last_page"
        :per-page="meta.per_page"
        :first="links.first"
        :last="links.last"
        :prev="links.prev"
        :next="links.next"
        @next="handleNext"
        @prev="handlePrev"
      />
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/pro-solid-svg-icons';
import pick from 'lodash/pick';

import VetsterPagination from '@/components//VetsterPagination';
import VetsterReview from '@/components/VetsterReview';

library.add({
  faChevronLeft,
  faChevronRight,
});

export default {
  name: 'VetsterReviews',

  components: {
    VetsterPagination,
    VetsterReview,
  },

  props: {
    partnerId: {
      type: String,
      default: null,
    },
    reviews: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      results: [],
      loading: true,
      pageReady: false,
      meta: [],
      links: [],
    };
  },

  computed: {
    hasResults() {
      return this.results?.length > 0;
    },
  },

  async created() {
    if (this.reviews) {
      this.setPage1();
    } else {
      await this.fetchReviews();
    }

    this.pageReady = true;
  },

  methods: {
    async fetchReviews(page) {
      this.loading = true;
      const response = await this.$api.get(`p/partner/${this.partnerId}/reviews`, {
        params: {
          page: page || 1,
          perPage: 10,
        },
      });

      this.results = response.data.data;
      this.meta = response.data.meta;
      this.links = response.data.links;
      this.params = response.data.params;
      this.loading = false;
    },
    /**
     * SEO optimization renders reviews ?page=1 in the Blade template.
     */
    setPage1() {
      this.results = this.reviews.data;
      this.meta = pick(this.reviews, [
        'total',
        'from',
        'to',
        'current_page',
        'last_page',
        'per_page',
      ]);
      this.links = {
        first: this.reviews.from,
        last: this.reviews.last_page,
        prev: null,
        next: this.reviews.last_page > this.reviews.current_page
          ? this.reviews.current_page + 1
          : null,
      };
      this.loading = false;
    },
    handleNext(inputs) {
      if (inputs.page <= 0) {
        inputs.page = 1;
      }
      this.fetchReviews(inputs.page);
    },

    handlePrev(inputs) {
      if (inputs.page <= 0) {
        inputs.page = 1;
      }
      this.fetchReviews(inputs.page);
    },
  },
};
</script>
